import React from "react";
import { Card, Typography } from "antd";
import VariationBadge from "./VariationBadge";

const { Text } = Typography;

interface KpiCardProps {
  icon?: React.ReactNode;
  label: string;
  value: React.ReactNode;
  variation?: number | null;
  vsLabel?: string;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
  valueClassName?: string;
  vsLabelClassName?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  label,
  value,
  variation,
  vsLabel,
  className,
  iconClassName,
  labelClassName,
  valueClassName,
  vsLabelClassName,
}) => (
  <Card className={className} hoverable>
    {icon && <div className={iconClassName}>{icon}</div>}
    <Text className={labelClassName}>{label}</Text>
    <div className={valueClassName}>{value}</div>
    {variation !== undefined && <VariationBadge value={variation} />}
    {vsLabel && <Text className={vsLabelClassName}>{vsLabel}</Text>}
  </Card>
);

export default KpiCard;
